<template>
  <component :is="layout"></component>
</template>

<script>
import tmplDefault from '@/templates/default/components/nav-bar'
import tmplCanalSur from '@/templates/canal-sur/components/nav-bar'

export default {
  name: 'Navbar',
  components: {
    'tmpl-DFT': tmplDefault, // defecto
    // 'tmpl-PIN': tmplPinkoTV, // Pinko TV
    // 'tmpl-PLN': tmplPlay, // Play
    // 'tmpl-PLY': tmplPlayTrailer, // Play + trailer
    // 'tmpl-APP': tmplApple, // Apple
    'tmpl-SUR': tmplCanalSur // Canal Sur
  },
  computed: {
    layout () {
      let layout = 'tmpl-' + this.$store.getters.getData.template1
      return this.$options.components[layout] ? layout : 'tmpl-DFT'
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue